<template>
  <section-row v-if="isSection"
               :index="index"
               :section="item"
               :size="size"
               :isManaged="isManaged"
               @edit="onEditSection(item)"
               @delete="onDelete"
               @hide-section="onHideSection"
               @show-section="onShowSection"
               @moveup="onMove(item,-1)"
               @movedown="onMove(item, 1)"
               @click-content="onClickContent"/>
  <product-item-row v-else-if="isProduct"
                    :index="index"
                    :product="item"
                    :size="size"
                    :isManaged="isManaged"
                    @edit="onEditProduct(item)"
                    @delete="onDelete"
                    @move="onMove"
                    @click-content="onClickContent"/>
</template>

<script>

import { Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { Components } from '@core/helpers/decorators';
import Vue from 'vue';
import { ProductItem, Section } from '../models';
import ProductItemRow from './ProductItemRow.vue';
import SectionRow from './SectionRow.vue';

@Component
@Components({ ProductItemRow, SectionRow })
export default class SectionProductRow extends Vue {
  @Prop({ Number, default: 0 }) index;

  @Prop({ Number, default: 0 }) size;

  @Prop({ Boolean, default: true }) isManaged;

  @Prop({
    Object,
    validator(item) {
      return item instanceof Section || item instanceof ProductItem;
    }
  }) item;

  get isProduct() {
    return this.item instanceof ProductItem;
  }

  get isSection() {
    return this.item instanceof Section;
  }

  onEditProduct(item) {
    this.$emit('edit-product', item);
  }

  onEditSection(item) {
    this.$emit('edit-section', item);
  }

  onDelete(itemGuid) {
    this.$emit('delete', itemGuid);
  }

  onMove(item, value) {
    this.$emit('move', item, value);
  }

  onClickContent(item) {
    this.$emit('click-content', item);
  }

  onHideSection(item) {
    this.$emit('hide-section', item);
  }

  onShowSection(item) {
    this.$emit('show-section', item);
  }
}
</script>
